import gql from 'graphql-tag'

export const IS_REVIEW_FORM_SUBMITTED = gql`
  query Query {
    isReviewFormAlreadySubmitted
  }
`
